export enum NoteParentType {
  ORDER = 'ORDER',
  PERMIT_APPLICATION = 'PERMIT_APPLICATION',
}

export interface Note {
  id: string;
  author: string;
  tags: string[];
  content: string;
  parent: { id: string; name: string; type: NoteParentType };
  createdAt: string;
  updatedAt: string;
}
